export const LEARN_MORE_LINK =
    'http://www.hp.com/us-en/all-in-plan/printers.html?jumpid=ba_us_hpg_ot_ot_cm000011_co_ot_platinumsunset-aa';

export const DASHBOARD_LINK = 'https://instantink.hpconnected.com/signin';
